import { HttpClient, HttpEvent, HttpEventType, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class UploadService {

  constructor(private http: HttpClient) { }

  uploadPatientProfile(data:FormData): Observable<any> {
    return this.http.post(environment.upload,data);
  }

  uploadDcouments(data:FormData): Observable<any> {
    return this.http.post(environment.upload,data);
  }

  // Upload with progress tracking
  uploadDocumentsWithProgress(data: FormData): Observable<any> {
    const req = new HttpRequest('POST', environment.upload, data, {
      reportProgress: true
    });

    return this.http.request(req).pipe(
      map((event: HttpEvent<any>) => {
        switch (event.type) {
          case HttpEventType.UploadProgress:
            const progress = event.total ? Math.round((100 * event.loaded) / event.total) : 0;
            return { type: 'progress', progress };
          
          case HttpEventType.Response:
            return { type: 'response', body: event.body };
          
          default:
            return { type: 'other' };
        }
      })
    );
  }
  
  
  
  
  
}
